/**
 * @generated SignedSource<<6f9eca7feccc4f4fec77f2a6e66e178b>>
 * @relayHash fb3186b4aa1fa2959829104c52c416aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 34616299c9adb35c8c01b7fe644b8c7a9a116cb67e27ffec59f915c00d8884ea

import type { ConcreteRequest } from 'relay-runtime';
export type useJsmAdminPermissionQuery$variables = {
  cloudId: string;
};
export type useJsmAdminPermissionQuery$data = {
  readonly jira: {
    readonly hasJsmAdminAccess: boolean | null;
  } | null;
};
export type useJsmAdminPermissionQuery = {
  response: useJsmAdminPermissionQuery$data;
  variables: useJsmAdminPermissionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "kind": "ScalarField",
        "name": "hasJsmAdminAccess"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useJsmAdminPermissionQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useJsmAdminPermissionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "34616299c9adb35c8c01b7fe644b8c7a9a116cb67e27ffec59f915c00d8884ea",
    "metadata": {},
    "name": "useJsmAdminPermissionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f8433e5032048f2040ec4cc44ee83592";

export default node;
